// ⚠️ AUTO-GENERATED — DO NOT EDIT MANUALLY
// Source: ./svg/IconCancel.svg — regenerate with `nx run creditflowresearch-uilib:icons-generate --write`
import BaseIcon from './BaseIcon';
import type { IIconProps } from './types';

const IconCancel = (props: IIconProps) => (
  <BaseIcon viewBox="0 0 16 16" fill="currentColor" { ...props }>
    <path d="M7.99989 5.3926L2.60751 0.000112529L0 2.6074L5.39282 8L0 13.3927L2.60751 16L8.00011 10.6074L13.3925 15.9999L16 13.3926L10.6072 8L16 2.6074L13.3925 0L7.99989 5.3926Z" />
  </BaseIcon>
);

export default IconCancel;
